<template>
<!--    <Header/>-->
    <router-view/>
    <Footer/>
<!--    <Footer/>-->
</template>

<script setup>
import Footer from "@/components/Footer";

</script>